"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textEllipsis = void 0;

var _styledComponents = require("styled-components");

// eslint-disable-next-line import/prefer-default-export
const textEllipsis = (0, _styledComponents.css)(["white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"]);
exports.textEllipsis = textEllipsis;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ0ZXh0RWxsaXBzaXMiLCJjc3MiXSwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvdXRpbGl0eS90ZXh0LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ3N0eWxlZC1jb21wb25lbnRzJ1xuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIGltcG9ydC9wcmVmZXItZGVmYXVsdC1leHBvcnRcbmV4cG9ydCBjb25zdCB0ZXh0RWxsaXBzaXMgPSBjc3NgXG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuYFxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7QUFDTyxNQUFNQSxZQUFZLE9BQUdDLHFCQUFILGlFQUFsQiJ9